import {version}  from '../../../package.json';

(function () {
    angular.module('JB.translate.srv', ['auth.srv'])
        .constant('DEFAULT_LOCALE', 'english')
        .factory('Translate', ['$q', '$http', '$rootScope', 'DEFAULT_LOCALE', translate]);

    function translate($q, $http, $rootScope, DEFAULT_LOCALE) {

        let getCookie = (cname) => {
            let name = cname + "=",
                ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }

                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        };

        var _getLocaleData = function (locale) {
            return $http.get('app/locales/' + locale + '.json');
        };

        var _getUserLocale = function () {
            var lang = getCookie('L'),
                cLang = lang.toLowerCase(),
                hasLang = [
                    'spanish',
                    'english',
                    'chinese',
                    'chineset',
                    'german',
                    'japanese',
                    'italian',
                    'portuguese',
                    'brazil',
                    'french',
                    'indian'
                ].indexOf(cLang);

            if(hasLang === -1) {
                cLang = 'english';
            }

            return cLang;
        };


        // return a complete directory, english extending
        var _createDirectory = function () {
            var userLocale = _getUserLocale(),
                localPromise = _getLocaleData(userLocale),
                basePromise = _getLocaleData('english'),
                _resolveBasePromise = function(){
                    // if there is an error load base data, so at least english displays
                    basePromise.success(function (data) {
                        if($rootScope.localStorageSupported) {
                            localStorage.setItem(`dictionary-${userLocale}-${version}`, JSON.stringify(data));
                        }

                        $rootScope.directory = data;
                        $rootScope.translate = _getTranslateKey;
                    });
                };

            if(userLocale !== 'english'){
                $q.all([basePromise, localPromise]).then(function (resolved) {
                    $rootScope.directory = angular.extend({}, resolved[0].data, resolved[1].data);
                    if($rootScope.localStorageSupported) {
                        localStorage.setItem(`dictionary-${userLocale}-${version}`, JSON.stringify($rootScope.directory));
                    }
                    $rootScope.translate = _getTranslateKey;
                }).catch(function () {
                    _resolveBasePromise();
                });
            }else {
                _resolveBasePromise();
            }
            return $rootScope.translatePromise = basePromise;
        };

        const _deletePastStorage = () => {
            let arr = [];

            for (let i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).indexOf('dictionary-') > -1) {
                    arr.push(localStorage.key(i));
                }
            }

            if(arr.length) {
                let temp = arr.map((item) => item);

                for (let i = temp.length - 1; i >= 0; i--) {
                    if (arr[i].indexOf(version) > -1) {
                        arr.splice(i, 1);
                    }
                }
            }

            if(arr.length) {
                for (let i = 0; i < arr.length; i++) {
                    localStorage.removeItem(arr[i]);
                }
            }
        };

        const _getDirectory = () => {
            const userLocale = getCookie('L') || DEFAULT_LOCALE;
            const dictionary = localStorage.getItem(`dictionary-${userLocale}-${version}`);

            if (!dictionary || dictionary.length < 100) {
                _createDirectory();
                _deletePastStorage();
                if(!$rootScope.translate) {
                    $rootScope.translate = () => {};
                }
            }
            else {
                $rootScope.directory = JSON.parse(dictionary);
                $rootScope.translate = _getTranslateKey;
            }
        };

        const _getTranslateKey = (key) => $rootScope.directory[key] || "";

        // exports directory
        return {
            buildDirectory: _getDirectory
        }
    }
}());



// WEBPACK FOOTER //
// ./app/services/JBTranslate.js